export default "__VITE_ASSET__M0k7KjT6__"